/**
 * Structured debug logging for request-recording flow.
 * Enable via ?recDebug=1, ?debug=1, or localStorage.setItem('recDebug', '1')
 */
const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const DEBUG =
  typeof window !== 'undefined' &&
  (params?.get('recDebug') === '1' ||
    params?.get('debug') === '1' ||
    localStorage.getItem('recDebug') === '1');

export function dbg(prefix: string, label: string, data?: unknown): void {
  if (!DEBUG) return;
  const ts = performance.now().toFixed(1);
  const payload: Record<string, unknown> =
    data !== undefined
      ? (typeof data === 'object' && data !== null && !Array.isArray(data)
          ? { ...(data as Record<string, unknown>) }
          : { value: data })
      : {};
  payload.ts = `${ts}ms`;
  console.log(`[RECDBG][${prefix}] ${label}`, payload);
}

export function dbgGroup(prefix: string, label: string, fn: () => void): void {
  if (!DEBUG) return;
  console.groupCollapsed(`[RECDBG][${prefix}] ${label}`);
  try {
    fn();
  } finally {
    console.groupEnd();
  }
}

export { DEBUG };
